module.exports = __webpack_public_path__ + "img/emi.7ac67854.jpg";